"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SeekBar = void 0;
var React = __importStar(require("react"));
var react_1 = require("@xstate/react");
var classnames_1 = __importDefault(require("classnames"));
var video_context_1 = require("../../context/video-context");
var time_1 = require("@skillrecordings/time");
var utils_1 = require("../../utils");
var selectors_1 = require("../../selectors");
var slider_1 = require("@reach/slider");
var load_progress_bar_1 = require("./load-progress-bar");
var SeekBar = function (props) {
    var videoService = (0, video_context_1.useVideo)();
    var duration = (0, react_1.useSelector)(videoService, selectors_1.selectDuration);
    var currentTime = (0, react_1.useSelector)(videoService, selectors_1.selectCurrentTime);
    var ref = React.useRef(null);
    var _a = React.useState(false), isActive = _a[0], setActive = _a[1];
    var _b = React.useState(0), mousePosition = _b[0], setMousePosition = _b[1];
    var handleMouseEnter = function (e) {
        return setActive(true);
    };
    var handleMouseLeave = function () {
        return setActive(false);
    };
    function calculateDistance(event) {
        var node = ref === null || ref === void 0 ? void 0 : ref.current;
        var position = (0, utils_1.getPointerPosition)(node, event);
        return position.x;
    }
    return (React.createElement(slider_1.SliderInput, { ref: ref, onMouseMoveCapture: function (e) {
            setMousePosition(calculateDistance(e));
        }, onMouseOut: function () {
            setMousePosition(0);
        }, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, style: { width: '100%' }, min: 0, max: duration, value: currentTime, step: 0.5, handleAlignment: "contain", onChange: function (newValue) {
            videoService.send({
                type: 'SEEKING',
                seekingTime: newValue
            });
            videoService.send('END_SEEKING');
        }, "aria-label": "seek slider", getAriaValueText: function (value) {
            var currentValue = Number(value.toFixed(0));
            var currentTime = currentValue === 0
                ? '0 seconds'
                : (0, time_1.convertTimeWithTitles)(currentValue, {
                    showSeconds: true,
                    longForm: true
                });
            return (currentTime +
                " of ".concat((0, time_1.convertTimeWithTitles)(duration, {
                    showSeconds: true,
                    longForm: true
                })));
        } }, function (_a) {
        var hasFocus = _a.hasFocus;
        var isVisible = hasFocus || isActive;
        return (React.createElement(slider_1.SliderTrack, { className: (0, classnames_1["default"])('cueplayer-react-progress-slider', {
                'cueplayer-react-progress-slider-active': isVisible
            }) },
            React.createElement(load_progress_bar_1.LoadProgressBar, null),
            React.createElement("div", { className: (0, classnames_1["default"])('cueplayer-react-progress-slider-highlight'), style: {
                    width: mousePosition * 100 + '%'
                } }),
            React.createElement(slider_1.SliderRange, null),
            React.createElement(slider_1.SliderHandle, null)));
    }));
};
exports.SeekBar = SeekBar;
